<header>
  <h2 [innerHTML]="'TITLE.ORDER_CHECKOUT' | t">Order Checkout</h2>
  <ul class="progress">
    <li
      [innerHTML]="'TERM.NAVIGATION.SHIPMENT' | t"
      [ngClass]="{ active: currentPage === 'shipment', past: currentPage !== 'shipment' }"
    >
      Shipment
    </li>
    @if (isIncludeCampaign) {
      <li
        [innerHTML]="'TERM.NAVIGATION.SELECT_GIFT' | t"
        [ngClass]="{ active: currentPage === 'campaign', past: currentPage !== 'campaign' }"
      >
        Select Gift
      </li>
    }
    <li
      [innerHTML]="'TERM.NAVIGATION.PAYMENT' | t"
      [ngClass]="{ active: currentPage === 'payment', past: currentPage !== 'payment' }"
    >
      >Payment
    </li>
    <li
      [innerHTML]="'ORDER.COMPLETE.TITLE' | t"
      [ngClass]="{ active: currentPage === 'complete', past: currentPage !== 'complete' }"
    >
      >Order Complete
    </li>
  </ul>
</header>
